export type AnimeTag = "动物拟人番" | "兽耳萌番" | "宠物日常" | "猫狗动画";

export interface Anime {
  id: number;
  title: string;
  tag: AnimeTag;
  rating: string;
  episodes: string;
  year: string;
  status: string;
  protagonist: string;
  desc: string;
  image: string;
}

export interface CategoryItem {
  id: string;
  name: string;
  en: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: CategoryItem[] = [
  {
    id: "cat-1",
    name: "动物拟人番",
    en: "Anthropomorphic",
    desc: "动物们化身主角，说话、上学、冒险，拟人化设定超有趣",
    icon: "ri-footprint-line",
    count: 86,
  },
  {
    id: "cat-2",
    name: "兽耳萌番",
    en: "Kemonomimi",
    desc: "兽耳、尾巴、毛茸茸，萌点拉满的治愈系日常",
    icon: "ri-heart-3-line",
    count: 124,
  },
  {
    id: "cat-3",
    name: "宠物日常",
    en: "Pet Daily",
    desc: "柴犬柯基猫咪的温馨日常，铲屎官必看的治愈时光",
    icon: "ri-home-heart-line",
    count: 95,
  },
  {
    id: "cat-4",
    name: "猫狗动画",
    en: "Cat & Dog",
    desc: "猫咪与狗狗的对手戏，打打闹闹又相依为命",
    icon: "ri-puzzle-line",
    count: 67,
  },
  {
    id: "cat-5",
    name: "冒险物语",
    en: "Adventure",
    desc: "狗狗踏上旅途，伙伴与成长的主题总是那么动人",
    icon: "ri-compass-3-line",
    count: 52,
  },
  {
    id: "cat-6",
    name: "治愈剧场",
    en: "Healing",
    desc: "毛茸茸的拥抱感，看完心情瞬间被治愈",
    icon: "ri-sun-line",
    count: 78,
  },
];

export const animeList: Anime[] = [
  {
    id: 1,
    title: "柴犬观察日记",
    tag: "宠物日常",
    rating: "9.6",
    episodes: "全12话",
    year: "2024",
    status: "已完结",
    protagonist: "主角：小柴「团团」",
    desc: "记录一只傲娇柴犬与新手铲屎官的同居日常，用镜头般细腻的笔触描绘柴犬的每一个小表情。",
    image: "https://readdy.ai/api/search-image?query=Cute%20shiba%20inu%20dog%20character%20warm%20orange%20illustration%2C%20sitting%20beside%20a%20cozy%20window%2C%20playful%20expression%2C%20soft%20studio%20lighting%2C%20clean%20pastel%20warm%20background%2C%20anime%20style%2C%20high%20detail%2C%20adorable%20pet%20daily%20theme&width=600&height=800&seq=xg-anime-01&orientation=portrait",
  },
  {
    id: 2,
    title: "兽耳咖啡馆",
    tag: "兽耳萌番",
    rating: "9.4",
    episodes: "全24话",
    year: "2023",
    status: "已完结",
    protagonist: "主角：猫耳店长「千穗」",
    desc: "一家开在街角的兽耳咖啡馆，猫耳、犬耳、狐耳店员轮番登场，暖心的营业日常治愈每位客人。",
    image: "https://readdy.ai/api/search-image?query=Anime%20cat%20ear%20girl%20barista%20holding%20coffee%20cup%2C%20warm%20cafe%20interior%2C%20golden%20light%2C%20kemonomimi%20cute%20style%2C%20soft%20pastel%20cream%20background%2C%20cozy%20healing%20atmosphere%2C%20high%20detail%20illustration&width=600&height=800&seq=xg-anime-02&orientation=portrait",
  },
  {
    id: 3,
    title: "汪汪侦探社",
    tag: "猫狗动画",
    rating: "9.2",
    episodes: "全13话",
    year: "2025",
    status: "连载中",
    protagonist: "主角：侦探犬「柯尔」",
    desc: "一只嗅觉敏锐的侦探犬与傲娇猫咪搭档破案，城市悬案在毛茸茸的智慧面前迎刃而解。",
    image: "https://readdy.ai/api/search-image?query=Anime%20detective%20dog%20with%20magnifying%20glass%20and%20trench%20coat%2C%20cat%20partner%2C%20mystery%20city%20street%20backdrop%2C%20warm%20orange%20toned%20illustration%2C%20playful%20but%20smart%20vibe%2C%20high%20detail&width=600&height=800&seq=xg-anime-03&orientation=portrait",
  },
  {
    id: 4,
    title: "哈士奇的奇妙冒险",
    tag: "动物拟人番",
    rating: "9.0",
    episodes: "全16话",
    year: "2023",
    status: "已完结",
    protagonist: "主角：二哈「雪橇」",
    desc: "爱闯祸的哈士奇无意间发现通往异世界的大门，一场脑洞大开又爆笑的冒险就此展开。",
    image: "https://readdy.ai/api/search-image?query=Anthropomorphic%20husky%20adventurer%20wearing%20backpack%20and%20scarf%2C%20fantasy%20door%20in%20background%2C%20energetic%20expression%2C%20warm%20golden%20light%2C%20anime%20illustration%2C%20adventure%20story%2C%20high%20detail&width=600&height=800&seq=xg-anime-04&orientation=portrait",
  },
  {
    id: 5,
    title: "奶狗打工记",
    tag: "宠物日常",
    rating: "8.8",
    episodes: "全10话",
    year: "2025",
    status: "连载中",
    protagonist: "主角：实习生「奶糖」",
    desc: "刚踏出校园的小奶狗成为职场新人，笨拙却真诚的它在打工人日常里慢慢成长。",
    image: "https://readdy.ai/api/search-image?query=Cute%20puppy%20office%20worker%20wearing%20tie%20and%20holding%20documents%2C%20modern%20office%20setting%2C%20warm%20lighting%2C%20anime%20style%2C%20soft%20cream%20background%2C%20daily%20work%20comedy%2C%20adorable%20high%20detail&width=600&height=800&seq=xg-anime-05&orientation=portrait",
  },
  {
    id: 6,
    title: "狐狸学园",
    tag: "兽耳萌番",
    rating: "9.3",
    episodes: "全26话",
    year: "2022",
    status: "已完结",
    protagonist: "主角：狐耳学生「阿狸」",
    desc: "森林深处的兽耳学园里，一群毛茸茸的学生在欢笑与泪水中追逐梦想，青春感拉满。",
    image: "https://readdy.ai/api/search-image?query=Anime%20fox%20ear%20school%20girl%20in%20uniform%20with%20backpack%2C%20campus%20with%20cherry%20trees%2C%20warm%20afternoon%20light%2C%20kemonomimi%20school%20life%2C%20cute%20pastel%20illustration%2C%20high%20detail&width=600&height=800&seq=xg-anime-06&orientation=portrait",
  },
  {
    id: 7,
    title: "猫咪与流浪犬",
    tag: "猫狗动画",
    rating: "9.5",
    episodes: "全12话",
    year: "2024",
    status: "已完结",
    protagonist: "主角：流浪犬「旺仔」",
    desc: "一只孤独的流浪犬和一只傲娇家猫偶然相遇，彼此守护的故事温柔又催泪。",
    image: "https://readdy.ai/api/search-image?query=Anime%20stray%20dog%20and%20house%20cat%20sitting%20together%20under%20warm%20street%20lamp%2C%20night%20scene%20with%20soft%20golden%20glow%2C%20emotional%20touching%20atmosphere%2C%20anime%20illustration%2C%20high%20detail&width=600&height=800&seq=xg-anime-07&orientation=portrait",
  },
  {
    id: 8,
    title: "小柯基的甜品店",
    tag: "宠物日常",
    rating: "8.9",
    episodes: "全10话",
    year: "2025",
    status: "连载中",
    protagonist: "主角：店长「糯米」",
    desc: "圆滚滚的小柯基开了一家甜品店，用摇尾巴般的甜度治愈每一位食客的坏心情。",
    image: "https://readdy.ai/api/search-image?query=Corgi%20chef%20dog%20wearing%20apron%20holding%20a%20cake%2C%20warm%20bakery%20interior%2C%20sweet%20pastel%20cream%20background%2C%20cute%20anime%20style%2C%20cozy%20healing%20dessert%20theme%2C%20high%20detail&width=600&height=800&seq=xg-anime-08&orientation=portrait",
  },
  {
    id: 9,
    title: "狼少年与雪原",
    tag: "动物拟人番",
    rating: "9.1",
    episodes: "全22话",
    year: "2022",
    status: "已完结",
    protagonist: "主角：狼少年「凛」",
    desc: "生于雪原的狼少年为寻找族群踏上旅途，凛冽风光下藏着最柔软的守护之心。",
    image: "https://readdy.ai/api/search-image?query=Anthropomorphic%20wolf%20boy%20with%20white%20hair%20standing%20in%20snowy%20mountain%20landscape%2C%20cool%20and%20warm%20contrast%2C%20warm%20sunset%20glow%2C%20epic%20yet%20soft%20anime%20illustration%2C%20high%20detail&width=600&height=800&seq=xg-anime-09&orientation=portrait",
  },
  {
    id: 10,
    title: "汪汪乐队的夏天",
    tag: "兽耳萌番",
    rating: "8.7",
    episodes: "全12话",
    year: "2025",
    status: "连载中",
    protagonist: "主角：主唱犬「音音」",
    desc: "五个热爱音乐的毛茸茸成员组建乐队，用歌声唱响夏日的热情与梦想。",
    image: "https://readdy.ai/api/search-image?query=Anime%20dog%20band%20members%20playing%20guitar%20and%20microphone%20on%20stage%2C%20warm%20concert%20lights%2C%20energetic%20summer%20festival%20vibe%2C%20cute%20anime%20illustration%2C%20high%20detail&width=600&height=800&seq=xg-anime-10&orientation=portrait",
  },
  {
    id: 11,
    title: "腊肠犬的旅行",
    tag: "宠物日常",
    rating: "8.6",
    episodes: "全8话",
    year: "2023",
    status: "已完结",
    protagonist: "主角：旅行犬「小短」",
    desc: "身体虽短却心怀远方，一只腊肠犬带着小包袱环游世界，记录沿途的温暖相遇。",
    image: "https://readdy.ai/api/search-image?query=Dachshund%20dog%20traveler%20with%20tiny%20backpack%20standing%20on%20a%20scenic%20viewpoint%2C%20warm%20sunset%20skyline%2C%20travel%20adventure%2C%20cute%20anime%20style%2C%20soft%20warm%20tone%2C%20high%20detail&width=600&height=800&seq=xg-anime-11&orientation=portrait",
  },
  {
    id: 12,
    title: "狮子与狗狗物语",
    tag: "动物拟人番",
    rating: "9.0",
    episodes: "全18话",
    year: "2024",
    status: "已完结",
    protagonist: "主角：狮王「雷恩」",
    desc: "威严的狮王与小小的狗狗之间意外的深厚友谊，打破物种藩篱的动人传说。",
    image: "https://readdy.ai/api/search-image?query=Anthropomorphic%20lion%20king%20and%20small%20dog%20friendship%2C%20savanna%20sunset%20warm%20light%2C%20touching%20brotherhood%20theme%2C%20epic%20anime%20illustration%2C%20high%20detail&width=600&height=800&seq=xg-anime-12&orientation=portrait",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "「小狗看番」是什么类型的网站？",
    a: "小狗看番是一个专注于狗狗主角、动物拟人、兽耳萌系与宠物日常类动画的垂直内容站。我们按人气整理猫狗动画与动物伙伴番，为萌宠控提供一站式的找番、看番与讨论社区。",
  },
  {
    q: "网站收录的番剧有哪些分类？",
    a: "主要分为四大类：动物拟人番、兽耳萌番、宠物日常与猫狗动画，另外还有冒险物语和治愈剧场两个专题板块，方便不同口味的用户快速找到合心意的作品。",
  },
  {
    q: "每部番剧的评分是怎么来的？",
    a: "评分综合了站内用户的打星、追番人数与讨论热度，按人气动态排序。数据每 24 小时更新一次，让最新的热门作品始终排在最前面。",
  },
  {
    q: "在网站上看番需要付费吗？",
    a: "小狗看番目前提供免费的番剧检索、介绍与评分服务。观看正片需跳转到对应的官方正版平台，我们强烈建议支持正版，版权内容均遵循原平台的授权规则。",
  },
  {
    q: "如何向网站推荐喜欢的番剧？",
    a: "你可以通过页面底部的联系表单或邮箱向我们投稿推荐，编辑团队审核通过后会把作品收录进对应的分类与榜单，让更多同好看到。",
  },
];